// SeccionEventos.jsx

import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import ImageWithBlur from "./ImageWithBlur";

function SeccionEventos({ 
  profesionalInfo, 
  isMobile,
  handleEventoClick 
}) {

  // Función para formatear fecha de evento al estilo "lunes 1 de enero del 2027"
  const formatearFechaEvento = (fecha) => { // Parámetro 'hora' eliminado
    // Parsear fecha en formato "DD-MM-YYYY" (ejemplo: "31-01-2026")
    const partes = fecha.split('-');
    const dia = parseInt(partes[0], 10);
    const mes = parseInt(partes[1], 10) - 1; // Restar 1 porque los meses en JS van de 0-11
    const año = parseInt(partes[2], 10);
    
    const date = new Date(año, mes, dia);
    
    const diasSemana = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    
    const diaSemana = diasSemana[date.getDay()];
    const diaFormateado = date.getDate(); // Retorna número sin cero a la izquierda (1, 2, 3... no 01, 02, 03)
    const mesTexto = meses[date.getMonth()];
    const añoFormateado = date.getFullYear();
    
    return `${diaSemana} ${diaFormateado} de ${mesTexto} del ${añoFormateado}`; // Hora eliminada del return
  };

  const renderEventCards = () => {
    if (!profesionalInfo || !profesionalInfo.eventos) {
      return null;
    }

    const eventos = profesionalInfo.eventos;

    if (!eventos || eventos.length === 0) {
      return null;
    }

    return (
      <>
        {eventos.map((evento) => {
          return (
            <Card
              key={evento.id_evento}
              sx={{ mb: 2, borderRadius: 2, boxShadow: 3 }}
            >
              <CardContent>
                <Box sx={{ 
                  display: "flex", 
                  flexDirection: { xs: "column", md: "row" },
                  alignItems: { xs: "center", md: "center" },
                  gap: { xs: 0, md: 2 },
                  mb: 0 
                }}>
                  {/* Imagen */}
                  <Box sx={{ 
                    maxWidth: { xs: "90%", md: "300px" }, // Cambiado de 350px a 300px
                    width: { xs: "280px", md: "300px" }, // Cambiado de 350px a 300px para coincidir con ancho de imagen
                    height: { xs: "120px", md: "150px" },
                    mb: { xs: 2, md: 0 },
                    display: "flex",
                    justifyContent: "flex-start", // Cambiado de "center" a "flex-start"
                    flexShrink: 0
                  }}>
                    <ImageWithBlur
                      src={evento.evento_foto}
                      alt={evento.evento_nombre}
                      width={isMobile ? "280px" : "300px"}
                      height={isMobile ? "120px" : "150px"}
                    />
                  </Box>
                  
                  {/* Información del evento */}
                  <Box sx={{ 
                    width: { xs: "100%", md: "auto" },
                    flex: { xs: "none", md: 1 },
                    textAlign: { xs: "left", md: "left" }, // Centrado en mobile, izquierda en desktop
                    display: "flex",
                    flexDirection: "column",
                    minHeight: { xs: "auto", md: "150px" },
                    mb: 0 
                  }}>
                      <Typography
                        sx={{ fontFamily: "Quicksand-Bold", fontSize: { md: "16px", xs: "14px" }, mb: 0 }}
                      >
                        {evento.evento_nombre}
                      </Typography>
                      
                      <Box
                        sx={{
                          display: "inline-block",
                          backgroundColor: "#f0f4ff",
                          color: "#3B82F6",
                          fontFamily: "Quicksand-Medium",
                          fontSize: { md: "15px", xs: "13px" },
                          borderRadius: 2,
                          paddingLeft: 0.75,
                          paddingRight: 0.75,
                          paddingTop: 0.25,
                          paddingBottom: 0.25,
                          mb: 0.25,
                          marginLeft: -0.75,
                          textAlign: "left",
                          width: "auto",
                          alignSelf: "flex-start",
                        }}
                      >
                        {evento.evento_modalidad === "presencial" ? "Evento presencial" : "Evento online"}
                      </Box>
                      
                      <Typography 
                        sx={{ fontFamily: "Quicksand-Regular", color: "#626262", fontSize: { md: "15px", xs: "13px" }, mb: 0 }}
                      >
                        {formatearFechaEvento(evento.evento_dia)} 
                      </Typography>
                      
                      <Typography
                        sx={{ fontFamily: "Quicksand-Bold", color: "#3B82F6", mb: 2, fontSize: { md: "16px", xs: "14px" } }}
                      >
                        {evento.evento_precio_total_clp}
                      </Typography>

                      {/* Espacio flexible solo en desktop */}
                    <Box sx={{ flex: { xs: 0, md: 1 } }} />
                    
                    {/* Botón */}
                    <Box sx={{ 
                      display: "flex", 
                      flexDirection: { xs: "column", md: "row" },
                      justifyContent: { xs: "flex-start", md: "flex-end" },
                      alignItems: { xs: "stretch", md: "flex-end" },
                      gap: { xs: 2, md: 0 },
                      width: { xs: "100%", md: "auto" },
                      mb: 0 
                    }}>
                      <Button
                        variant="contained"
                        disableRipple
                        disableElevation
                        disableFocusRipple
                        onClick={() => handleEventoClick(evento)}
                        sx={{
                          fontFamily: "Quicksand-Bold",
                          backgroundColor: "#3B82F6",
                          "&:hover": { 
                            backgroundColor: "#3B82F6",
                            boxShadow: "none !important",
                          },
                          "&:active": {
                            backgroundColor: "#3B82F6",
                            boxShadow: "none !important",
                          },
                          "&:focus": {
                            backgroundColor: "#3B82F6",
                            boxShadow: "none !important",
                          },
                          borderRadius: 2,
                          width: { xs: "100%", md: "auto" },
                          py: 1,
                          fontSize: { md: "16px", xs: "14px" },
                          boxShadow: "none !important",
                          transition: "none !important",
                          "& .MuiTouchRipple-root": {
                            display: "none",
                          },
                        }}
                      >
                        Ver más
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          );
        })}
      </>
    );
  };

  if (!profesionalInfo || !profesionalInfo.eventos || profesionalInfo.eventos.length === 0) {
    return null;
  }

  return (
    <>
      <Typography
        sx={{
          mt: 3,
          mb: 2,
          fontFamily: "Quicksand-Bold",
          fontSize: { md: "20px", xs: "18px" },
        }}
      >
        Eventos
      </Typography>
      {renderEventCards()}
    </>
  );
}

export default SeccionEventos;
